// material-ui
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

export default function Footer() {
  return (
    <Stack
      direction={{ xs: 'column', sm: 'row' }}
      sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between', p: '24px 16px 0px', mt: 'auto' }}
    >
      <Typography variant="caption">
        &copy; {new Date().getFullYear()} Bizora. All rights reserved.
      </Typography>
      <Stack direction="row" sx={{ gap: 1.5, alignItems: 'center', justifyContent: 'space-between' }}>
        <Link href="#" variant="caption" color="text.primary">
          Privacy Policy
        </Link>
        <Link href="#" variant="caption" color="text.primary">
          Terms of Service
        </Link>
        <Link href="#" variant="caption" color="text.primary">
          Support
        </Link>
      </Stack>
    </Stack>
  );
}
